<template>
    <main-content-wrapper>
        <h1>{{ title }}</h1>
        <p class="text">{{ text }}</p>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import utils from "../store/utils";


    export default {
        name: "EmailSent",
        components: {MainContentWrapper},
        computed: {
            title: utils.vuexBuildSetGet(this, 'application', 'sent_email.title'),
            text: utils.vuexBuildSetGet(this, 'application', 'sent_email.text')
        },
        mounted() {
            this.$trackPageVisit('email-sent');
        },
    }
</script>

<style scoped>
.text {
    text-align: center;
    font-weight: 500;
}
</style>